﻿import {useMemo} from "react";
import {useMediaQuery, useTheme} from "@mui/material";

const DEFAULT_DESKTOP_ZOOM = 8.7;
const DEFAULT_TABLET_ZOOM = 8.6;
const DEFAULT_PHONE_ZOOM = 8.2;

export const useDefaultMapZoom = () => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  return useMemo(() => {
    if (isPhone) {
      return DEFAULT_PHONE_ZOOM;
    }
    if (isTablet) {
      return DEFAULT_TABLET_ZOOM;
    }
    return DEFAULT_DESKTOP_ZOOM;
  }, [isPhone, isTablet]);
}
